import React from 'react';
import {ReviewUnit} from "@onegovbugs/onegov-react-components";
import styles from "./ReviewUnitApplication.module.scss";

export const SpeciesDetailsReviewUnit = ({props, speciesDetails, onEditUrl}) => {   

    return (
        <ReviewUnit
            title={"Interstate Licence Details"}
            onEdit={() => props.history.push({
                pathname: onEditUrl,
              })}
        >
            <div className={`row ${styles.infoLine}`}>
                <div className={"col-12 col-md-6"}>
                    <div>
                        <em>Licence Number</em>
                    </div>
                    <div className={styles.camelCase}>{(speciesDetails && speciesDetails.licenceNumber ? speciesDetails.licenceNumber : "")}</div>
                </div>
                <div className={"col-12 col-md-6"}>
                    <div>
                        <em>Import/Export Permit or Movement Number</em>
                    </div>
                    <div className={styles.camelCase}>{(speciesDetails && speciesDetails.permitMovementNumber ? speciesDetails.permitMovementNumber : "")}</div>
                </div>                
            </div>
            
            {
                speciesDetails.speciesList.length > 0 &&
                <hr className={styles.hrEmployment}/>
            }

            

            {/* {(speciesDetails.speciesList && speciesDetails.speciesList.length === 0) &&
            
            <div className={`row ${styles.infoLine}`}>
                <div className={"col-12 col-md-6"}>
                    No species details added
                </div>
            </div>     
            } */}

            {

                (
                    (speciesDetails.speciesList.map((el, i) => (
                    
                    <div key={"species-"+i} >
                        {i!=0 && (<hr className={styles.hrEmployment}/>)}
                        <div className={`row ${styles.infoLine}`}>
                            <div className={"col-12 col-md-6"}>
                                <div>
                                <em>Species Code</em>
                                </div>
                                <div>{el.speciesCode}</div>
                            </div>
                            <div className={"col-12 col-md-6"}>
                                <div>
                                    <em>Number of Fauna</em>
                                </div>
                                <div>{el.speciesNoOfFauna}</div>
                            </div>                            
                        </div>
                        <div className={`row ${styles.infoLine}`}>
                            <div className={"col-12 col-md-6"}>
                                <div>
                                    <em>Common Name</em>
                                </div>
                                <div>{el.speciesCommonName}</div>
                            </div>                            
                            <div className={"col-12 col-md-6"}>
                                <div>
                                <em>Genus</em>
                                </div>
                                <div>{el.speciesGenus}</div>
                            </div>
                        </div>
                        <div className={`row ${styles.infoLine}`}>
                            <div className={"col-12 col-md-6"}>
                                <div>
                                <em>Species</em>
                                </div>
                                <div>{el.species}</div>
                            </div>                            
                            <div className={"col-12 col-md-6"}>
                                <div>
                                    <em>Subspecies</em>
                                </div>
                                <div>{el.subspecies}</div>
                            </div>                          
                        </div>                     
                    </div>
                    ))
                ))

            }
    
        </ReviewUnit>
    )
}